import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearMyAnalyticsAction, getMyAnalytics } from '../../redux/actions/meActions';

const useFetchMyAnalytics = () => {
  const dispatch = useDispatch();
  const analytics = useSelector((state) => state.analytics);
  const loading = useSelector((state) => state.analytics?.loading);

  const fetchAnalytics = useCallback(async () => {
    await dispatch(getMyAnalytics());
  }, [dispatch]);

  useEffect(() => {
    fetchAnalytics();
  }, [fetchAnalytics]);

  useEffect(() => {
    return () => {
      dispatch(clearMyAnalyticsAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchAnalytics();
  };

  return { loading, analytics, refresh };
};

export default useFetchMyAnalytics;
